import * as React from 'react';
import { DetailsList, DetailsListLayoutMode, IColumn, MarqueeSelection, Stack, Selection, ShimmeredDetailsList, ActionButton, Separator, SelectionMode, ProgressIndicator, Link, Icon, DetailsHeader, IRenderFunction, IDetailsHeaderProps, IDetailsHeaderStyles, useTheme, IDetailsColumnStyles } from '@fluentui/react';
import { IStatusMessage } from '../../../Models/IStatusMessage';
import { IRoom } from '../../../Models/Rooms/IRoom';
import { PageTitle } from '../../PageTitle';
import { IOrderListItem } from '../../../Models/Order/IOrderListItem';
import { orderStateEnumToString } from '../../../Models/Order/OrderStateEnum';
import { EventPriceTypeEnum } from '../../../Models/Event/EventPriceTypeEnum';

interface IMyOrderListViewProps {
    items: IOrderListItem[];
    isLoading: boolean;
    selectItem: (item: IOrderListItem) => void;
}

export const MyOrderListView: React.FunctionComponent<IMyOrderListViewProps> = (props) => {

    const [selected, setSelected] = React.useState<IOrderListItem[]>([]);
    const [selectionState] = React.useState(new Selection({

        onSelectionChanged: () => {
            const selected = selectionState.getSelection() as IOrderListItem[];
            setSelected(selected);
        },
    }));

    React.useEffect(() => {
        if (selected.length > 0) {
             props.selectItem(selected[0]);
        }
    }, [selected])

    const theme = useTheme();

    const headerStyle: Partial<IDetailsColumnStyles> = {
        cellName: {
            fontFamily: "Comfortaa, serif",
            color: theme.palette.blue,
        },
    }

    const _columns: IColumn[] = [
        { key: 'id', name: 'Id', fieldName: 'id', minWidth:50, maxWidth: 100, isResizable: true, styles: headerStyle },
        { key: 'event', name: 'Akce', fieldName: 'event', minWidth: 100, maxWidth: 400, isResizable: true, styles: headerStyle },
        { key: 'price', name: 'Cena/žák', isCollapsible: true, fieldName: 'price', minWidth: 80, maxWidth: 150, isResizable: true, styles: headerStyle },
        { key: 'orderState', name: 'Stav', isCollapsible:true, fieldName: 'orderState', minWidth: 80, maxWidth: 150, isResizable: true, styles: headerStyle },
        ];

    const renderPrice = (item: IOrderListItem) => {
        return (
            <span style={{ height: '100%', display: 'flex', alignItems: 'center' }}>
                {item.priceType === EventPriceTypeEnum.ByEvent ? <span>{item.price + ",- Kč/akce"}</span>
                    : item.firstSemesterPrice === item.secondSemesterPrice ?
                      <span>{item.firstSemesterPrice===-1? "Neobjednáno":item.firstSemesterPrice + ",- Kč/pololetí"}</span>
                    : <span>{item.firstSemesterPrice === -1 ? "Neobjednáno" : ",- Kč/ 1 pololetí"}<br />{item.secondSemesterPrice === -1 ? "Neobjednáno" : item.secondSemesterPrice + ",- Kč/ 2 pololetí"}</span>
                }
            </span>
        )
    }

    const renderItemColumn = (item: IOrderListItem, index?: number, column?: IColumn) => {
        if (index != undefined && column != undefined) {
            const fieldContent = item[column.fieldName as keyof IOrderListItem];
            switch (column.key) {
                case "orderState":
                    return <span style={{ height: '100%', display: 'flex', alignItems: 'center' }}>{orderStateEnumToString(item.orderState)}</span>
                case "price":
                    return <span style={{ height: '100%', display: 'flex', alignItems: 'center' }}>
                        {renderPrice(item) }
                    </span>
                case 'orderStxxate':
                    return <Stack horizontalAlign="start" styles={{ root: { paddingLeft: 15 } }}><Icon title="Online meeting" styles={{ root: { fontSize: 16 } }} iconName="JoinOnlineMeeting" /></Stack>
                default:
                    return <span style={{ height: '100%', display: 'flex', alignItems: 'center' }}>{fieldContent}</span>;
            }
        }
        else {
            return (<div></div>)
        }
    }

    const headerRowStyle: Partial<IDetailsHeaderStyles> = {
        root: {
            borderColor: theme.palette.blue,
            borderBottomWidth: 2
        }
    }

    const onRenderDetailsHeader: IRenderFunction<IDetailsHeaderProps> = (props, defaultRender) => {
        if (props) {
            props = { ...props, styles: headerRowStyle };
            return (
                <DetailsHeader
                    {...props}
                />
            );
        }
        return null;
    }



    return (
        <Stack styles={{ root: { paddingLeft: 20, paddingRight: 20 } }}>
            <PageTitle title="Objednávky" />
            <Stack styles={{ root: { height: 10 } }}>
                {props.isLoading ? <ProgressIndicator /> : null}
            </Stack>
            <MarqueeSelection selection={selectionState}>
                <ShimmeredDetailsList
                    items={props.items}
                    columns={_columns}
                    setKey="set"
                    onRenderDetailsHeader={onRenderDetailsHeader}
                    selectionMode={SelectionMode.single}
                    layoutMode={DetailsListLayoutMode.justified}
                    onRenderItemColumn={renderItemColumn}
                    selection={selectionState}
                    selectionPreservedOnEmptyClick={false}
                    ariaLabelForSelectionColumn="Objednávky"
                    ariaLabelForSelectAllCheckbox="Objednávky"
                    checkButtonAriaLabel="Vyber Objednávky"
                    onItemInvoked={(item: IOrderListItem) => props.selectItem(item)}
                />
            </MarqueeSelection>
        </Stack>
    )
}
